import { Offer } from '@/reservation/reservation.model';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PricePipe } from '../../../../common/pipes/price.pipe';
import { NgClass } from '@angular/common';

@Component({
	selector: 'app-choose-offer-to-change-dialog',
	standalone: true,
	imports: [MatCardModule, MatDialogModule, MatButtonModule, PricePipe, NgClass],
	templateUrl: './choose-offer-to-change-dialog.component.html',
	styleUrl: './choose-offer-to-change-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseOfferToChangeDialogComponent {
	readonly offers = inject<Offer[]>(MAT_DIALOG_DATA);
	readonly selectedOfferId = signal<number>(null);

	private readonly dialog = inject(MatDialogRef);

	selectOffer(offerId: number): void {
		this.selectedOfferId.set(offerId);
	}

	submitAndCloseDialog(): void {
		this.dialog.close(this.selectedOfferId());
	}
}
